import { action, observable } from 'mobx';

import BaseStore from '../base-store';

abstract class ObjectStore<T, E> extends BaseStore<E> {
  @observable data: T;

  @action.bound
  protected onLoad(data: T) {
    this.loading = false;
    this.error = undefined;

    this.data = data;
  }

  @action.bound
  protected onError(error: E) {
    this.loading = false;
    this.error = error;
  }
}

export default ObjectStore;
